// Internal preview only. Live checkout must validate codes and prices server-side.
export const HEADPHONE_PREVIEW_CODE = "CLARITYVIP";
export function isHeadphonePreviewCode(code: string) {
  return code.trim().toUpperCase() === HEADPHONE_PREVIEW_CODE;
}
export function headphonePreviewTotals(items: { productId: string; price: number; quantity: number }[], applied: boolean) {
  let subtotal = 0;
  let discount = 0;
  for (const item of items) {
    const cents = Math.round(item.price * 100) * item.quantity;
    const rate = applied ? item.productId === "no-5909" ? 0.5 : item.productId === "solitaire-t" ? 0.2 : 0 : 0;
    subtotal += cents;
    discount += Math.round(cents * rate);
  }
  return { subtotal: subtotal / 100, discount: discount / 100, total: (subtotal - discount) / 100 };
}
